import { Box, HStack, Text } from "@chakra-ui/react";
import { FC, useEffect, useMemo, useState } from "react";

import { useDebounce } from "../../../../hooks";
import { SbpTransferPageTermItem } from "./SbpTransferPageTermItem.tsx";
import { useSbpTransferStore } from "../../../../../../store/sbpTransferStore.ts";
import { ISbpTransferTerm } from "../../../../../../api/sbpTransfer/types.ts";
import { useGetSbpTransferAvailableTermsQuery } from "../../../../../../api/sbpTransfer";

export const SbpTransferPageTerm: FC = () => {
  const { data } = useGetSbpTransferAvailableTermsQuery();
  const term = useSbpTransferStore(s => s.term);
  const setTerm = useSbpTransferStore(s => s.setTerm);

  const [localSelectedTerm, setLocalSelectedTerm] = useState<ISbpTransferTerm | null>(term);
  const debouncedSelectedTerm = useDebounce(localSelectedTerm, 800);

  const terms = useMemo(() => {
    if (!Array.isArray(data?.termInfo)) {
      return [];
    }

    return [...data.termInfo].sort((a, b) => (a.term || 0) - (b.term || 0));
  }, [data]);

  useEffect(() => {
    if (!debouncedSelectedTerm) {
      return;
    }

    setTerm(debouncedSelectedTerm);
  }, [debouncedSelectedTerm]);

  return (
    <Box>
      <Text mb="9px" fontSize="12.5px" lineHeight="1">Выберите срок погашения</Text>

      <HStack spacing={3} justifyContent="flex-start" flexWrap="wrap">
        {terms.length > 0
          ? terms.map(t => (
            <SbpTransferPageTermItem
              key={t.term}
              term={t.term!}
              isSelected={t.fasCode === localSelectedTerm?.fasCode}
              onSelect={() => { setLocalSelectedTerm(t); }}
            />
          ))
          : <Text fontSize="12.5px" variant="brand" lineHeight="1">нет доступных сроков</Text>}
      </HStack>
    </Box>
  );
};
